<template>
  <div class="glossary">
    <h1 class="title is-3" data-line-start="0" data-line-end="1">
      <a id="Glossary_0"></a>Glossary
    </h1>
      <b-field label="Filter" label-position="on-border">
        <b-input placeholder="Type to filter" v-model="searchText"></b-input>
        <p class="control" v-show="searchText.length > 0">
          <button @click="searchText = ''" class="button">clear</button>
        </p>
      </b-field>
    <br />
    <p class="term" v-for="t in filteredTerms" :key="t.id">
      <strong>{{t.word}}</strong>
      - {{t.definition}}
    </p>
  </div>
</template>

<style lang="scss">
.glossary {
  .term {
    margin: 10px 0px;
  }
}
</style>

<script>
export default {
  name: "Glossary",
  data() {
    return {
      searchText: '',
      terms: [
        {
          definition:
            "Acetate or Vivak plastic® card with salmon scale impressions used to read fish age using a microfiche reader. Scale impressions are made on the acetate by applying heat and pressure to scales stored on a gummed card.",
          group: "Age estimation",
          id: 1,
          word: "Acetate"
        },
        {
          definition:
            "The length of time that an organism has lived or a thing has existed; measured in years, months, days, or other units.",
          group: "Age estimation",
          id: 2,
          word: "Age"
        },
        {
          definition:
            "The degree to which the age data are close to the actual age.",
          group: "Age estimation",
          id: 3,
          word: "Age accuracy"
        },
        {
          definition:
            "Evaluation of fish age using biological data such as scale circuli growth pattern interpretation, length, or weight.",
          group: "Age estimation",
          id: 4,
          word: "Age estimation"
        },
        {
          definition:
            "Technique for interpreting fish age from growth patterns on fish structures such as scales or otoliths.",
          group: "Age estimation",
          id: 5,
          word: "Age reading"
        },
        {
          definition:
            "(Annuli, plural) Growth zone representing one year of life. An annulus is commonly identified at the end of winter growth.",
          group: "Age estimation",
          id: 6,
          word: "Annulus"
        },
        {
          definition:
            "The portion of the scale that is nearer to the head. Circuli and annuli form on this part of the scale. In live fish, this part is subcutaneous (under the skin).",
          group: "Age estimation",
          id: 7,
          word: "Anterior field"
        },
        {
          definition:
            "Plane of view or measurement from the posterior field of the scale to the scale’s anterior margin.",
          group: "Age estimation",
          id: 8,
          word: "Axis"
        },
        {
          definition:
            "Nexus of the posterior and anterior fields of the salmon scale and the location of the circuli “tails”.",
          group: "Age estimation",
          id: 9,
          word: "Base"
        },
        {
          definition:
            "The difference between an estimated value and the true value of the parameter.",
          group: "Age estimation",
          id: 10,
          word: "Bias"
        },
        {
          definition:
            "Used to determine total age; important to consider when looking at the marginal growth (growth after the final winter annulus). January 1st is commonly accepted birthday for Chinook salmon in Alaska, though different run-types have different birthdays that are based on the timing of spawner returns. For example, Central Valley Fall-run Chinook salmon have an assumed birthdate of September 1 (O’Farrell et al. 2010), spring-run fish have an assumed birthdate of May 1 and winter-run fish have an assumed birthdate of March 1 (O’Farrell et al. 2012).",
          group: "Age estimation",
          id: 11,
          word: "Birth date"
        },
        {
          definition:
            "False annulus theoretically created by stressful conditions that cause decreased fish growth represented by relatively closely-spaced circuli within an annulus. Checks can be difficult to distinguish from annuli.",
          group: "Age estimation",
          id: 12,
          word: "Check"
        },
        {
          definition:
            "(Circuli, plural) Growth increment radiating out from the focus (Figure A2). Individual ring or ridge on a scale. The spacing between circuli reflects fish growth rate (Fisher and Pearcy 2005).",
          group: "Age estimation",
          id: 13,
          word: "Circulus"
        },
        {
          definition:
            "The termination or “ends” of circuli at the base of the scale. Generally, circuli tails turn away from the focus at the beginning of winter growth and towards the focus at the end of each winter. Circuli tail appearance is helpful for estimating of fish age.",
          group: "Age estimation",
          id: 14,
          word: "Circuli tails"
        },
        {
          definition:
            "Method of age notation for salmonid scales: the number of winters spent in freshwater after emergence from the redd before going to sea, for example 1 winter = age-1.X, followed by the number of winters spent at sea, three winters = age-X.3 or four winters = age-X.4.",
          group: "Age estimation",
          id: 15,
          word: "European age notation"
        },
        {
          definition:
            "Point of origin of the scale and the area contained within the first circulus. The focus is frequently used as a reference point when referring to parts of a scale.",
          group: "Age estimation",
          id: 16,
          word: "Focus"
        },
        {
          definition:
            "Circuli formed when the fish resides in fresh water. They tend to be more closely-spaced, thinner, and lighter in appearance than circuli formed after entry into an estuarine or marine environment (Figure A2). Generally, the ends of freshwater circuli (“tails”) point towards the focus.",
          group: "Age estimation",
          id: 17,
          word: "Freshwater circuli"
        },
        {
          definition:
            "Area on the scale between the last freshwater annulus and circuli formed in the ocean.",
          group: "Age estimation",
          id: 18,
          word: "Freshwater plus"
        },
        {
          definition:
            "The portion of the scale that was formed after fish growth in fresh water. Counting winter zones provides fish age in fresh water.",
          group: "Age estimation",
          id: 19,
          word: "Freshwater zone"
        },
        {
          definition:
            "Method of age notation for salmon scales (Gilbert and Rich 1927): Nn , wherein N = the total age of the fish including the year in the gravel, and n = age at which the fish went to the ocean.",
          group: "Age estimation",
          id: 20,
          word: "Gilbert-Rich age notation"
        },
        {
          definition:
            "Card with a “gummed” or sticky and numbered side. Salmon scales are placed on the sticky side. Sample information is recorded on the non-sticky side. High heat and pressure are used to create impressions of the gummed cards on an acetate for reading and long-term preservation of scale samples.",
          group: "Age estimation",
          id: 21,
          word: "Gummed card"
        },
        {
          definition:
            "Fish spawned and reared in a hatchery environment. Hatchery-origin fish often exhibit even and significant growth patterns prior to release (freshwater-rearing phase). In contrast, wild fish tend to have uneven growth during the freshwater-rearing phase and undergo a rapid compensatory growth upon entering the ocean.",
          group: "Age estimation",
          id: 22,
          word: "Hatchery fish"
        },
        {
          definition:
            "A scale that was placed on gummed card upside down (e.g. with growth ridges (circuli) placed into the mounting medium) resulting in an unreadable impression on the acetate card.",
          group: "Age estimation",
          id: 23,
          word: "Inverted scale"
        },
        {
          definition:
            "Scale collected near the groove on the skin along the side of the fish with a network of sensory canals (the lateral line). Scale shape is distorted around the pore and the scale margin has an indent.",
          group: "Age estimation",
          id: 24,
          word: "Lateral line scale"
        },
        {
          definition:
            "The border or edge of a scale.  Outer circumference of scale where new growth accrues and scale material accrues.",
          group: "Age estimation",
          id: 25,
          word: "Margin"
        },
        {
          definition:
            "Circuli formed while the fish is in the ocean. These circuli tend to be less closely-spaced and thicker than circuli formed in fresh water.",
          group: "Age estimation",
          id: 26,
          word: "Marine circuli"
        },
        {
          definition:
            "Description of a scale sampled from outside of the preferred sampling area on the fish (see preferred area, Mosher 1963).",
          group: "Age estimation",
          id: 27,
          word: "Non-preferred"
        },
        {
          definition:
            "The border between the freshwater and marine zones. Delineated by the transition from the relatively slower freshwater zone growth to an increase in growth when a fish enters the ocean. Thus, after ocean entrance, an increase in circuli spacing and size is apparent and circuli tails turn away from the focus.",
          group: "Age estimation",
          id: 28,
          word: "Ocean entrance"
        },
        {
          definition:
            "Portion of the scale that is nearer to the fish’s tail. In live fish, this portion is exposed to the fish’s environment and is covered by pigment. Circuli are not present on this portion of the scale. This is the first portion of the scale to be resorbed and is resorbed to a higher degree than the anterior field.",
          group: "Age estimation",
          id: 29,
          word: "Posterior field"
        },
        {
          definition: "Repeatability of a given measure or age reading.",
          group: "Age estimation",
          id: 30,
          word: "Precision"
        },
        {
          definition:
            "Area on the fish located three scale rows above the lateral line between the posterior insertion of the dorsal fin and anterior insertion of the anal fin (Mosher 1963).",
          group: "Age estimation",
          id: 31,
          word: "Preferred area"
        },
        {
          definition:
            "Scales sampled within the preferred sampling area for a species of fish.",
          group: "Age estimation",
          id: 32,
          word: "Preferred scale"
        },
        {
          definition: "Distance from focus to a specific point on the scale.",
          group: "Age estimation",
          id: 33,
          word: "Radius"
        },
        {
          definition:
            "Scale taken from a fish of known origin, sample date, and/or age. Known-age samples are from validated by tagging (or other mark) studies by subtracting the year the fish was marked from the year the fish was recovered to determine age. This is used by scale readers to “calibrate” or become familiar with scale patterns and associate these with origin, sample date, and age.",
          group: "Age estimation",
          id: 34,
          word: "Reference sample"
        },
        {
          definition:
            "Area of a scale with missing circuli caused by reforming a lost scale. Sometimes freshwater age cannot be determined for regenerated scales due to subsequent reformation.",
          group: "Age estimation",
          id: 35,
          word: "Regenerated"
        },
        {
          definition:
            "Resorption (verb). Scales that are resorbed have portions that have lost their structure. The anterior field loses its circuli and the posterior field looses its characteristics. During resorption, the fish uses scale tissue (fibrous and calcified scale layers) as a source of mineral and somatic energy reserves during gonadal maturation, migration, and spawning that leads to a loss of scale tissue (Bigler 1989). Resorption of the scale margin generally starts on the posterior field and progresses near the base of the anterior field along the lateral margins of the scale until the whole scale margin is affected (Mosher 1968).",
          group: "Age estimation",
          id: 36,
          word: "Resorbed"
        },
        {
          definition:
            "Apparent dissipation or dispersion of circuli tissue located between and around circuli tails at the base of the scale. Reticulation can appear globular or ladder-like. Presence and appearance can be used as part of discerning species.",
          group: "Age estimation",
          id: 37,
          word: "Reticulation"
        },
        {
          definition:
            "(Plus growth) Circuli formed after the ocean winter (annulus) on the margin of a scale. This zone is often resorbed in mature salmon, where the amount of resorption increases the closer the salmon is to spawning. Depending on life history, stock, or sample day, scale appearance information from reference scale samples, known-age reference samples are preferred, can be used to justify adding another not complete annulus to a scale reading.",
          group: "Age estimation",
          id: 38,
          word: "Saltwater plus"
        },
        {
          definition:
            "The method of checking or proving the validity or accuracy of an something. Age validation is usually performed by using known-age specimens collected from a tagging or marking studies. Some validation methods include: coded wire tag (CWT), Parentage Based Tagging (PBT), or PIT tagging fish at a known life stage, typically smolts, then subtracting release year from the recovery year to validates the number of years as the age, typically ocean age.",
          group: "Age estimation",
          id: 39,
          word: "Validation"
        },
        {
          definition:
            "Region of similar structure or definition. For example, the “annual growth zone” consists of one year of growth, usually one summer zone and one winter zone. Most Chinook salmon have one freshwater zone with zero to one annulus, and one marine zones with two to four annuli.",
          group: "Age estimation",
          id: 40,
          word: "Zone"
        },
        {
          definition:
            "Salmon that return to fresh water during the fall to spawn.",
          id: 41,
          word: "Fall-run",
          group: "Life history"
        },
        {
          definition:
            "Sexually mature male salmon of an age group younger than the youngest females in the population (Quinn 2005). For example, in the Columbia Basin, male Chinook salmon that return to spawn after their first year in the ocean (one-ocean fish); total age 3. Alaska (Yukon): Male Chinook salmon returning after spending two years in the ocean (two-ocean fish); total age 4.",
          id: 42,
          word: "Jack",
          group: "Life history"
        },
        {
          definition:
            "Female that returns to spawn one year earlier than the bulk of the female salmon in the run. Jills are very rare (Quinn 2005).",
          id: 43,
          word: "Jill",
          group: "Life history"
        },
        {
          definition:
            "A male Chinook salmon that smolts and matures in the same year. Return to fresh water occurs before forming an ocean annulus. Mini-jacks are defined for the Columbia River as an upstream migrating Chinook salmon with a fork length between 15-30 cm. Scale patterns, mean number of circuli in fresh water and salt water, and circuli spacing are described for scales from mini-jack Chinook salmon in Idaho and Bonneville Dam by Johnson et al. (2012).",
          id: 44,
          word: "Mini-jack",
          group: "Life history"
        },
        {
          definition:
            "(sub-yearling) Life history strategy of emigrating from fresh water to the ocean before their first winter; no freshwater winter annulus is apparent on the scale.",
          id: 45,
          word: "Ocean-type",
          group: "Life history"
        },
        {
          definition:
            "Life history strategy of rearing in a reservoir before emigrating to the ocean (Connor et al. 2005). Fish size at ocean entrance is generally larger for this life history than others; most scales show the freshwater annulus and ocean entrance at the same position.",
          id: 46,
          word: "Reservoir-type",
          group: "Life history"
        },
        {
          definition:
            "Fish that are not anadromous, although their cohorts may be. Examples include kokanee (sockeye salmon); rainbow trout (steelhead); Chinook salmon, and coho salmon. Resident fish are identified by their small size compared to same age anadromous fish, lack of saltwater annuli, and large fresh water zone on the scales.",
          id: 47,
          word: "Resident",
          group: "Life history"
        },
        {
          definition:
            "Salmon that return to fresh water during the spring to spawn.",
          id: 48,
          word: "Spring-run",
          group: "Life history"
        },
        {
          definition:
            "(yearling) Life history strategy of rearing a year or more in fresh water before emigrating to the ocean. Scales show at least one freshwater annulus.",
          id: 49,
          word: "Stream-type",
          group: "Life history"
        },
        {
          definition:
            "Salmon that return to fresh water during the summer to spawn.",
          id: 50,
          word: "Summer-run",
          group: "Life history"
        }
      ]
    }
  },
  computed: {
    filteredTerms() {
      const search = this.searchText.toLowerCase().trim();
      if (!search) return this.terms;
      return this.terms.filter(t => t.word.toLowerCase().indexOf(search) > -1);
    }
  },
};
</script>

